const FIVE_MINUTES = 5 * 60 * 1000;
export const DEFAULT_QUERYCLIENT_OPTIONS = {
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
            staleTime: FIVE_MINUTES,
        },
    },
};
